    function limpa_formulário_cep(campos) {
        // Limpa valores do formulário de cep.
        $.each(campos, function(index,obj){
            $("[data-tag-id='"+obj+"']").val("");
        });
    }

/*https://codigopostal.paraguay.gov.py/dinacopa/zona?pageSize=50000&first=0&sortField=&sortAsc=null&filtro=*/
    function buscacep(url,campos){
        //Consulta o webservice viacep.com.br/
        $.getJSON(url, function(dados) {
            if(!dados){
                //CEP pesquisado não foi encontrado.
                limpa_formulário_cep(campos);
                $.NotificationApp.send("Oh não!", "CEP não encontrado.", "top-right", "#bf441d", "error");
            }
            if (!("erro" in dados)) {
                //Atualiza os campos com os valores da consulta.
                $.each(dados, function(index, obj){
                    console.log(index);
                    $("[data-tag-id='"+index+"']").val(obj);
                });
            }else {
                //CEP pesquisado não foi encontrado.
                limpa_formulário_cep(campos);
                $.NotificationApp.send("Oh não!", "CEP não encontrado.", "top-right", "#bf441d", "error");
            }
        });
    }
    
    //Quando o campo cep perde o foco.
    $(document).on("blur","[data-tag-id='cep']",function() {
        let campos = ["logradouro","bairro","localidade","uf","ibge"];
        let qtd = /^[0-9]{8}$/;
        //Nova variável "cep" somente com dígitos.
        let cep = $(this).val().replace(/\D/g, '');
        let url_get = "https://viacep.com.br/ws/"+ cep +"/json/?callback=?";
        //Verifica se campo cep possui valor informado.
        switch($(this).val().replace(/\D/g, '').length){
            case 6:
                qtd = /^[0-9]{6}$/;
                url_get = $('base').attr('href') +'home/postalcode_py/'+cep;
                campos = ["dpto","distrito","barrio","nrocodigopostal"];
                break;
        }
        if (cep != "") {
            //Expressão regular para validar o CEP.
            let validacep = qtd;
            //Valida o formato do CEP.
            if(validacep.test(cep)) {
                //Preenche os campos com "..." enquanto consulta webservice.
                $.each(campos, function(index,obj){
                    $("[data-tag-id='"+obj+"']").val("...");
                });

                buscacep(url_get,campos);
            } //end if.
            else {
                //cep é inválido.
                limpa_formulário_cep(campos);
                $.NotificationApp.send("Oh não!", "Formato de CEP inválido.", "top-right", "#bf441d", "error");
            }
        } //end if.
        else {
            //cep sem valor, limpa formulário.
            limpa_formulário_cep(campos);
        }
    });

function get_mask_pais(id_pais){
    var url = $('base').attr('href') + 'admin/paises/get_mask_pais';
    $.ajax({
        url: url
        , data: { 
            idpais: id_pais
        }
        , type: 'POST'
        , dataType: 'json'
        , beforeSend: function () {
        }, error: function () {
            $.NotificationApp.send("Oh não!", "Erro Ajax.", "top-right", "#bf441d", "error");
        }, success: function (json) {
            //troca a mascara dos telefones
            $('.contato-tipo').each(function(index,obj){
                var value = $(obj).val();
                var input = $(obj).closest(".field").find('input');
                var mask;
                switch (value) {
                    case 'telefone':
                        if(mask = json.pais.tel_digitos_telefone){ 
                            input.mask(mask);
                        }else{
                            input.mask('00000000000000000000');
                        }
                        break;
                    case 'celular':
                        if(mask = json.pais.tel_digitos_celular){
                            input.mask(mask);
                        }else{
                            input.mask('00000000000000000000');
                        }
                        break;
                }
            });
        }, complete: function () {
        }
    });
};

/****************************  
 * ADICIONAR CONTATOS 
 * *************************/
//adicionar novo contato
if($('.contato-tipo').length){
    $(document).on('click', '#add', function () {

        var valor, i, cl, cln;
        i = $("#dynamic_field > div").length;
        i++;

        cl = $("#field-copy");

        valor = cl.find('.contato-tipo').val();

        cln = cl.clone(true);
        cln.attr({ 'id': 'row' + i });
        cln.find('button')
            .attr({ 'id': i })
            .removeClass('btn-success')
            .addClass('btn-danger btn_remove');
        cln.find('input[name="tel[]"]').val('');
        cln.find('button i')
            .removeClass('fa-plus')
            .addClass('fa-minus');
        cln.appendTo("#dynamic_field");

        switch (valor) {
            case 'telefone':
                cln.find('.contato-tipo').val('celular').trigger('change');
                break;
            case 'celular':
                cln.find('.contato-tipo').val('telefone').trigger('change');
                break;
        }
    });
    //trocar tipo de contato
    $(document).on('change', '.contato-tipo', function () {
        var id_pais;
        if($('#grupoloja-pais').length)
            var id_pais = $('#grupoloja-pais').val();
        if($('select#id_pais').length)
            var id_pais = $('select#id_pais').val();
        if($('input#id_pais').length)
            var id_pais = $('input#id_pais').val();
        //troca a mascara dos telefones
        get_mask_pais(id_pais);
    });
    //remover contato
    $(document).on('click', '.btn_remove', function () {
        var button_id = $(this).attr("id");
        $('#dynamic_field').find('#row' + button_id).remove();
    });
}

/****************************  
 * ADICIONAR OPTIONS 
 * *************************/
//adicionar novo option
    $(document).on('click', '#addoption', function () {

        var valor, i, cl, cln;
        i = $("#dynamic_field > div").length;
        i++;

        cl = $("#field-copy");

        valor = cl.find('.options').val();

        cln = cl.clone(true);
        cln.attr({ 'id': 'row' + i });
        cln.find('button')
            .attr({ 'id': i })
            .removeClass('btn-success')
            .addClass('btn-danger btn_removeoption');
        cln.find('input[name="value[]"]').val('');
        cln.find('input[name="texto[]"]').val('');
        cln.find('button i')
            .removeClass('fa-plus')
            .addClass('fa-minus');
        cln.appendTo("#dynamic_field");
    });
    //remover contato
    $(document).on('click', '.btn_removeoption', function () {
        var button_id = $(this).attr("id");
        $('#dynamic_field').find('#row' + button_id).remove();
    });

$(function(){
    $(document).on('keypress','[data-valida="numerico"]', function(e) {
        if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
        return false;
        }
    });
});

$('.custom-file-input').on('change',function(){
    //get the file name
    var fileName = $(this).val();
    //replace the "Choose a file" label
    $(this).next('.custom-file-label').html(fileName);
});

if($('#filtro_padrao_pais').length){
    //carregar os filtros do pais selecionado
    var pais = $('#filtro_padrao_pais').val();
    $.ajax({
        url: $('base').attr('href')+'admin/paises/getcampanhas'
        , data: { id_pais: pais }
        , type: 'POST'
        , dataType: 'json'
        , beforeSend: function () {
            $('#filtro_padrao_campanha').html('');
        }, error: function () {
            $.NotificationApp.send("Oh não!", "Erro Ajax.", "top-right", "#bf441d", "error");
        }, success: function (json) {
            // popula o select de campanhas
            $('#filtro_padrao_campanha').html(json.campanhas).prepend('<option value="">Todas</option>');
            
            var selected = $('#filtro_padrao_campanha').data('sel');
            $('#filtro_padrao_campanha').val(selected).prop('selected', true);
        }, complete: function () {
            
        }
    });

    $('#filtro_padrao_pais').on("change", function () {
        $.ajax({
            url: $('base').attr('href')+'admin/paises/getcampanhas'
            , data: { id_pais: $(this).val() }
            , type: 'POST'
            , dataType: 'json'
            , beforeSend: function () {
            }, error: function () {
                $.NotificationApp.send("Oh não!", "Erro Ajax.", "top-right", "#bf441d", "error");
            }, success: function (json) {
                location.reload();
            }, complete: function () {
                
            }
        })
    });
}

if($('#filtro_padrao_campanha').length){
    $('#filtro_padrao_campanha').on("change", function () {
        $.ajax({
            url: $('base').attr('href')+'admin/paises/getcampanhas'
            , data: { id_pais: $('#filtro_padrao_pais').val(), id_campanha: $(this).val() }
            , type: 'POST'
            , dataType: 'json'
            , beforeSend: function () {
            }, error: function () {
                $.NotificationApp.send("Oh não!", "Erro Ajax.", "top-right", "#bf441d", "error");
            }, success: function (json) {
                location.reload();
            }, complete: function () {                
            }
        })
    });
}
//MEDIA QUERY
function isMediaQueryMobile() {
    return window.matchMedia("screen and (min-width: 200px)").matches;
}
function isMediaQueryPhablet() {
    return window.matchMedia("screen and (min-width: 768px)").matches;
}
function isMediaQueryTablet() {
    return window.matchMedia("screen and (min-width: 992px)").matches;
}
function isMediaQueryDesktop() {
    return window.matchMedia("screen and (min-width: 1024px)").matches;
}
function isMediaQueryDesktopHD() {
    return window.matchMedia("screen and (min-width: 1200px)").matches;
}

function setStorage(dados) {
    localStorage.setItem(dados.item, dados.value);
}

function getStorage() {
    var msg = localStorage.getItem('msg');
    var tag = localStorage.getItem('tag');
    var type = localStorage.getItem('type');
    var summary = localStorage.getItem('summary');
    $.NotificationApp.send(tag, msg, "top-right","#5ba035",type);


  if (summary) {
  var summaryObj = JSON.parse(summary);
  var messages = summaryObj.Messages;
  var title = summaryObj.Title;
  var buttonText = summaryObj.Button_Text;
  var description = summaryObj.Description;
  var falha = summaryObj.Falha;
  let desc = description
    ? `<p style="color:#444; font-size:15px; margin-bottom:18px; text-align:left; font-weight:500;">${description}</p>`
    : '';
if(falha == 0)
{
    localStorage.clear();

    return
}
  let tabela = `
    <div class="card-tabela">
      <div class="tabela-titulo">
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16">
          <path d="M7.938 2.016a.13.13 0 0 1 .125 0l6.857 11.856c.03.052.03.116 0 .168a.13.13 0 0 1-.125.06H2.205a.13.13 0 0 1-.125-.06.146.146 0 0 1 0-.168L8.938 2.016zM8 4.002a.905.905 0 0 0-.9.918l.35 3.902a.55.55 0 0 0 1.1 0l.35-3.902A.905.905 0 0 0 8 4.002zM8 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
        </svg>
        Erros Encontrados no Arquivo
      </div>

      ${desc}

      <table class="tabela-erros">
        <thead>
          <tr>
            <th>Linha</th>
            <th>Descrição do Erro</th>
          </tr>
        </thead>
        <tbody>
  `;

  messages.forEach(e => {
    tabela += `
      <tr>
        <td>${e.Line}</td>
        <td>${e.Message}</td>
      </tr>
    `;
  });

  tabela += `
        </tbody>
      </table>
    </div>
  `;

  Swal.fire({
    title: title,
    html: tabela,
    icon: "error",
    width: "750px",
    showCloseButton: true,
    confirmButtonText: buttonText,
    confirmButtonClass: 'btn_confirme_tabela',
    background: "#fff",
  });
}


    localStorage.clear();
}

if(localStorage.getItem('msg')){
    getStorage();
}

if($('#campanha-view').length){
    $('#campanha-view').on('change',function(){
        var url = $(this).data('url');
        var campanha = $(this).val();
        $.post($('base').attr('href')+'home/set_campanha', { id: campanha})
        .done(function(data) {
            location.reload();
        });
    });
}

function viewfiletype(file){
    var extension = file.substr( (file.lastIndexOf('.') +1) );
    switch(extension){
        case 'mp4':
            return '<video src="'+file+'" class="w-100 img-responsiva" autoplay muted></video>';
            break;
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
            return '<img class="w-100 img-responsiva" src="'+file+'">';
            break;
    }
}

!function ($) {
    "use strict";

    var Components = function () { };

    //initializing tooltip
    Components.prototype.initTooltipPlugin = function () {
        $.fn.tooltip &&  $('[data-toggle="tooltip"]').tooltip()
    },

    //initializing popover
    Components.prototype.initPopoverPlugin = function () {
        $.fn.popover && $('[data-toggle="popover"]').popover()
    },

    //initializing toast
    Components.prototype.initToastPlugin = function() {
        $.fn.toast && $('[data-toggle="toast"]').toast()
    },

    //initializing form validation
    Components.prototype.initFormValidation = function () {
        $(".needs-validation").on('submit', function (event) {
            $(this).addClass('was-validated');
            if ($(this)[0].checkValidity() === false) {
                event.preventDefault();
                event.stopPropagation();
                return false;
            }
            return true;
        });
    },

    // Counterup
    Components.prototype.initCounterUp = function() {
        var delay = $(this).attr('data-delay')?$(this).attr('data-delay'):100; //default is 100
        var time = $(this).attr('data-time')?$(this).attr('data-time'):1200; //default is 1200
         $('[data-plugin="counterup"]').each(function(idx, obj) {
            $(this).counterUp({
                delay: delay,
                time: time
            });
         });
    },

    //peity charts
    Components.prototype.initPeityCharts = function() {
        $('[data-plugin="peity-pie"]').each(function(idx, obj) {
            var colors = $(this).attr('data-colors')?$(this).attr('data-colors').split(","):[];
            var width = $(this).attr('data-width')?$(this).attr('data-width'):20; //default is 20
            var height = $(this).attr('data-height')?$(this).attr('data-height'):20; //default is 20
            $(this).peity("pie", {
                fill: colors,
                width: width,
                height: height
            });
        });
        //donut
         $('[data-plugin="peity-donut"]').each(function(idx, obj) {
            var colors = $(this).attr('data-colors')?$(this).attr('data-colors').split(","):[];
            var width = $(this).attr('data-width')?$(this).attr('data-width'):20; //default is 20
            var height = $(this).attr('data-height')?$(this).attr('data-height'):20; //default is 20
            $(this).peity("donut", {
                fill: colors,
                width: width,
                height: height
            });
        });

        $('[data-plugin="peity-donut-alt"]').each(function(idx, obj) {
            $(this).peity("donut");
        });

        // line
        $('[data-plugin="peity-line"]').each(function(idx, obj) {
            $(this).peity("line", $(this).data());
        });

        // bar
        $('[data-plugin="peity-bar"]').each(function(idx, obj) {
            var colors = $(this).attr('data-colors')?$(this).attr('data-colors').split(","):[];
            var width = $(this).attr('data-width')?$(this).attr('data-width'):20; //default is 20
            var height = $(this).attr('data-height')?$(this).attr('data-height'):20; //default is 20
            $(this).peity("bar", {
                fill: colors,
                width: width,
                height: height
            });
         });
    },

    Components.prototype.initKnob = function() {
        $('[data-plugin="knob"]').each(function(idx, obj) {
           $(this).knob();
        });
    },

    Components.prototype.initTippyTooltips = function () {
        if($('[data-plugin="tippy"]').length > 0)
        tippy('[data-plugin="tippy"]');
    },

    Components.prototype.initShowPassword = function () {
        $("[data-password]").on('click', function() {
            if($(this).attr('data-password') == "false"){
                $(this).siblings("input").attr("type", "text");
                $(this).attr('data-password', 'true');
                $(this).addClass("show-password");
            } else {
                $(this).siblings("input").attr("type", "password");
                $(this).attr('data-password', 'false');
                $(this).removeClass("show-password");
            }
        });
    },

    Components.prototype.initMultiDropdown = function () {
        $('.dropdown-menu a.dropdown-toggle').on('click', function(e) {
            if (!$(this).next().hasClass('show')) {
              $(this).parents('.dropdown-menu').first().find('.show').removeClass("show");
            }
            var $subMenu = $(this).next(".dropdown-menu");
            $subMenu.toggleClass('show');
    
            return false;
        });  
        
        $(document).ready(function () {
            var t = $(".cd-accordion-menu");
            t.length > 0 && t.each(function () {
                var t = $(this);
                t.on("change", 'input[type="checkbox"]', function () {
                    var t = $(this);
                    t.prop("checked") ? t.siblings("ul").attr("style", "display:none;").slideDown(300) : t.siblings("ul").attr("style", "display:block;").slideUp(300)
                })
            })
        });
    },

    Components.prototype.initMediaScreen = function () {        

        //IMAGEM RESPONSIVA
        $(window).on('resize', function() {
            var el = $('.view-file-type');
            el.each(function() {
                var html;
                var file = $(this).data('src');
                if (isMediaQueryMobile()){
                    if ($(this).data('src-mobile')){
                        file = $(this).data('src-mobile');
                    }
                }
                if (isMediaQueryPhablet()){
                    if ($(this).data('src-phablet')){
                        file = $(this).data('src-phablet');
                    }
                }
                if (isMediaQueryTablet()){
                    if ($(this).data('src-tablet')){
                        file = $(this).data('src-tablet');
                    }
                }
                if (isMediaQueryDesktop()){
                    if ($(this).data('src-desktop')){
                        file = $(this).data('src-desktop');
                    }
                }
                if (isMediaQueryDesktopHD()){
                    if ($(this).data('src-desktop-hd')){
                        file = $(this).data('src-desktop-hd');
                    }
                }
                html = viewfiletype(file);
                $(this).html(html);
            });
        });

        $(window).trigger('resize');
    },

    //initilizing
    Components.prototype.init = function () {
        this.initTooltipPlugin(),
        this.initPopoverPlugin(),
        this.initToastPlugin(),
        this.initFormValidation(),
        this.initCounterUp(),
        this.initPeityCharts(),
        this.initKnob();
        this.initTippyTooltips();
        this.initShowPassword();
        this.initMultiDropdown();
        this.initMediaScreen();
    },

    $.Components = new Components, $.Components.Constructor = Components

}(window.jQuery),

function($) {
    "use strict";

    /**
    Portlet Widget
    */
    var Portlet = function() {
        this.$body = $("body"),
        this.$portletIdentifier = ".card",
        this.$portletCloser = '.card a[data-toggle="remove"]',
        this.$portletRefresher = '.card a[data-toggle="reload"]'
    };

    //on init
    Portlet.prototype.init = function() {
        // Panel closest
        var $this = this;
        $(document).on("click",this.$portletCloser, function (ev) {
            ev.preventDefault();
            var $portlet = $(this).closest($this.$portletIdentifier);
                var $portlet_parent = $portlet.parent();
            $portlet.remove();
            if ($portlet_parent.children().length == 0) {
                $portlet_parent.remove();
            }
        });

        // Panel Reload
        $(document).on("click",this.$portletRefresher, function (ev) {
            ev.preventDefault();
            var $portlet = $(this).closest($this.$portletIdentifier);
            // This is just a simulation, nothing is going to be reloaded
            $portlet.append('<div class="card-disabled"><div class="card-portlets-loader"></div></div>');
            var $pd = $portlet.find('.card-disabled');
            setTimeout(function () {
                $pd.fadeOut('fast', function () {
                    $pd.remove();
                });
            }, 500 + 300 * (Math.random() * 5));
        });
    },
    //
    $.Portlet = new Portlet, $.Portlet.Constructor = Portlet
    
}(window.jQuery),

function ($) {
    'use strict';

    var App = function () {
        this.$body = $('body'),
        this.$window = $(window)
    };

    /** 
     * Initlizes the controls
    */
    App.prototype.initControls = function () {
        // Preloader
        $(window).on('load', function () {
            $('#status').fadeOut();
            $('#preloader').delay(350).fadeOut('slow');
        });

        $('[data-toggle="fullscreen"]').on("click", function (e) {
            e.preventDefault();
            $('body').toggleClass('fullscreen-enable');
            if (!document.fullscreenElement && /* alternative standard method */ !document.mozFullScreenElement && !document.webkitFullscreenElement) {  // current working methods
                if (document.documentElement.requestFullscreen) {
                    document.documentElement.requestFullscreen();
                } else if (document.documentElement.mozRequestFullScreen) {
                    document.documentElement.mozRequestFullScreen();
                } else if (document.documentElement.webkitRequestFullscreen) {
                    document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (document.cancelFullScreen) {
                    document.cancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                }
            }
        });
        document.addEventListener('fullscreenchange', exitHandler );
        document.addEventListener("webkitfullscreenchange", exitHandler);
        document.addEventListener("mozfullscreenchange", exitHandler);
        function exitHandler() {
            if (!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
                console.log('pressed');
                $('body').removeClass('fullscreen-enable');
            }
        }
    },

    //initilizing
    App.prototype.init = function () {
        $.Portlet.init();
        $.Components.init();

        this.initControls();

        // init layout
        this.layout = $.LayoutThemeApp;
    
        this.layout.init();
    },

    $.App = new App, $.App.Constructor = App


}(window.jQuery),
//initializing main application module
function ($) {
    "use strict";
    $.App.init();
}(window.jQuery);

// Waves Effect
Waves.init();

// Feather Icons
feather.replace()